<section class="q-toasts">
  <div class="q-toast" *ngFor="let toast of toasts" id="{{toast.id}}">


    <!--<div class="container" *ngIf="toast.title !== '1567-NOTIF'">-->
    <div class="container" *ngIf="toast.title !== '1567-NOTIF'">
      <div class="row">
        <div class="col-sm-1 d-flex flex-column justify-content-center" [style.background-color]="toast.color">
          <div class="w-100 d-flex flex-row justify-content-center">
            <i class="fa {{ toast.faIcon }}"></i>
          </div>
        </div>
        <!--<div class="q-toast-desc col-sm-10" >{{ toast.title }}</div>-->
        <!--<div class="col-sm-10 d-flex flex-column justify-content-center" [innerHTML]="getSafeHtml(toast)"></div>-->
        <div class="col-sm-10 d-flex flex-column justify-content-center" [innerHTML]="toast.innerContent | safeHtml"></div>
        <div class="col-sm-1  d-flex flex-column justify-content-center">
          <div class="w-100 d-flex flex-row justify-content-center">
            <span class="q-toast-close text-light" (click)="removeToast(toast)">&#43;</span>
          </div>
        </div>
      </div>
    </div>

    <div class="card bg-light w-100" style="color:#666; font-size:.8rem;" *ngIf="toast.title === '1567-NOTIF'">
      <div class="card-header text-left">
        <i class="fas fa-exclamation-triangle fa-2x fa-pull-left fa-border text-primary"></i>
        <label class="ml-1 mt-1" style="font-weight:bolder; font-size:1.2rem;">Notification</label>
        <!--<i class="fas fa-times fa-lg float-right mr-2 mt-2" (click)="removeToast(toast)"></i>-->
        <i class="fas fa-times fa-2x fa-pull-right fa-border text-muted" (click)="removeToast(toast)" style="cursor:pointer;"></i>
      </div>
      <div class="card-body">
        <div class="row" style="padding:10px; font-size:.8rem;">
          <div class="col-12 wordwrap text-left" [innerHTML]="toast.innerContent | safeHtml"></div>
        </div>
      </div>
    </div>

  </div>
</section>
